const translations = {
  // Navigation
  nav_home: '首页',
  nav_projects: '项目',
  nav_studio: '工作室',
  nav_team: '团队',
  nav_design_process: '设计流程',
  nav_careers: '招聘',
  nav_contact: '联系我们',
  nav_healthcare: '医疗',
  nav_hospitality: '酒店',
  nav_mixed_use: '综合体',
  nav_offices: '办公',
  nav_residential: '住宅',
  nav_retail: '零售',
  nav_interior_design: '室内设计',
  nav_instagram: 'Instagram',
  nav_linkedin: 'LinkedIn',
  nav_tagline: '以清晰与克制塑造建筑。',

  // Hero
  hero_title: 'FS Architects',
  hero_subtitle: '静谧之形',
  hero_tagline_line1: '形式。静默。',
  hero_tagline_line2: '基础结构。',
  hero_cta: '查看项目',

  // Projects page
  projects_title: '项目',
  projects_count: '100+ 个项目',
  projects_all: '全部项目',
  projects_all_locations: '全部地点',
  projects_sort_date: '日期 ↑',
  projects_sort_alpha: '字母排序',
  projects_search: '搜索',
  projects_viewing: '正在查看',

  // Project detail
  detail_back: '返回项目列表',
  detail_year: '年份',
  detail_location: '地点',
  detail_category: '类别',
  detail_floor_plans: '平面图',
  detail_location_heading: '查看位置',
  detail_not_found: '未找到该项目。',
  detail_back_link: '返回项目列表',

  // Footer
  footer_tagline: '以清晰与克制塑造建筑。',
  footer_projects: '项目',
  footer_studio: '工作室',
  footer_get_in_touch: '联系我们',
  footer_newsletter: '订阅',
  footer_email_placeholder: '您的邮箱',
  footer_copyright: '© {year} FS Architects. 版权所有。',
  footer_privacy: '隐私政策',
  footer_terms: '使用条款',

  // ── Project 1: Metropolitan Healthcare Center ──
  proj_metropolitan_healthcare_center_name: '大都会医疗中心',
  proj_metropolitan_healthcare_center_address: '马尼拉大都会马卡蒂市',
  proj_metropolitan_healthcare_center_category: '医疗',
  proj_metropolitan_healthcare_center_description: '大都会医疗中心重新定义了菲律宾医疗建筑的标准。该设施以患者为中心的设计理念，将自然采光、生物亲和元素与直观的导视系统融为一体，形成统一的建筑语言。洁白的外立面与宽阔的玻璃幕墙营造出开阔宁静的氛围，有效缓解了临床环境中常见的焦虑感。从双层通高中庭到景观疗愈花园，每一处细节都旨在同时支持患者康复与员工身心健康。',
  proj_metropolitan_healthcare_center_fp0: '首层平面图',
  proj_metropolitan_healthcare_center_fp1: '二层平面图',
  proj_metropolitan_healthcare_center_fp2: '三层平面图',

  // ── Project 2: Coastal Resort & Spa ──
  proj_coastal_resort_spa_name: '海岸度假村与水疗中心',
  proj_coastal_resort_spa_address: '莱特省',
  proj_coastal_resort_spa_category: '酒店',
  proj_coastal_resort_spa_description: '这座度假村与水疗中心坐落于莱特岛原始海岸线旁，是建筑与自然和谐共生的典范。设计从菲律宾本土建筑传统中汲取灵感——架空结构、编织屏风与深远挑檐——以当代极简主义的视角重新诠释。每栋别墅均朝向海风方向，精心框取海洋景观。水疗馆掩映于成熟椰林之中，采用当地石材与回收木材，营造出沉稳奢华的氛围。',
  proj_coastal_resort_spa_fp0: '总平面图',
  proj_coastal_resort_spa_fp1: '别墅平面图',
  proj_coastal_resort_spa_fp2: '水疗馆平面图',

  // ── Project 3: Urban Living Complex ──
  proj_urban_living_complex_name: '城市生活综合体',
  proj_urban_living_complex_address: '宿务市',
  proj_urban_living_complex_category: '综合体',
  proj_urban_living_complex_description: '宿务市城市生活综合体代表了菲律宾高密度城市开发的全新模式。项目将住宅塔楼、商业裙楼与公共广场整合为一个统一的城市街区。立面系统——由预制混凝土板与内凹阳台构成的模块化网格——形成富有韵律的肌理，既回应热带气候，又保持鲜明的建筑个性。街道层面，连续的骑楼激活公共空间，为行人提供遮阴。',
  proj_urban_living_complex_fp0: '首层平面图',
  proj_urban_living_complex_fp1: '标准住宅层平面图',
  proj_urban_living_complex_fp2: '裙楼层平面图',

  // ── Project 4: Tech Hub Office Tower ──
  proj_tech_hub_office_tower_name: '科技枢纽办公塔楼',
  proj_tech_hub_office_tower_address: '塔吉格BGC',
  proj_tech_hub_office_tower_category: '办公',
  proj_tech_hub_office_tower_description: '科技枢纽办公塔楼矗立于博尼法西奥全球城天际线之上，是菲律宾科技产业的地标建筑。双层玻璃幕墙作为热缓冲层，在保持城市全景视野的同时显著降低太阳辐射热。室内每隔五层设置空中花园，为使用者提供非正式协作空间与生物亲和的休憩场所。首层设计为可渗透的公共空间，模糊了企业内部与BGC活力街道之间的边界。',
  proj_tech_hub_office_tower_fp0: '首层平面图',
  proj_tech_hub_office_tower_fp1: '标准办公层平面图',
  proj_tech_hub_office_tower_fp2: '空中花园层平面图',

  // ── Project 5: Hillside Residences ──
  proj_hillside_residences_name: '山坡住宅',
  proj_hillside_residences_address: '达沃市',
  proj_hillside_residences_category: '住宅',
  proj_hillside_residences_description: '山坡住宅俯瞰达沃市，依托自然地形而建。建筑群以层叠梯田式布局排列，最大限度减少土方工程，保留现有树冠。每个单元均设有宽敞的私人露台，朝向城市与远处阿波火山的轮廓。材料调色板——模板混凝土、耐候钢与当地硬木——经岁月沉淀愈发厚重，与自然景观的联结也随之加深。',
  proj_hillside_residences_fp0: '总平面图',
  proj_hillside_residences_fp1: '单元平面图',
  proj_hillside_residences_fp2: '露台层平面图',

  // ── Project 6: Lifestyle Shopping District ──
  proj_lifestyle_shopping_district_name: '生活方式购物街区',
  proj_lifestyle_shopping_district_address: '卡加延德奥罗市',
  proj_lifestyle_shopping_district_category: '零售',
  proj_lifestyle_shopping_district_description: '卡加延德奥罗生活方式购物街区为现代菲律宾消费者重新构想了零售体验。项目摒弃传统封闭式商场，以互联展馆、广场与景观步道构成开放式街区。建筑从城市丰富的文化遗产中汲取灵感，将本土工艺传统融入当代建筑元素。中央水景与成熟树冠共同营造出微气候，使户外购物在热带炎热中依然舒适宜人。',
  proj_lifestyle_shopping_district_fp0: '总平面图',
  proj_lifestyle_shopping_district_fp1: '首层平面图',
  proj_lifestyle_shopping_district_fp2: '上层平面图',

  // ── Project 7: Executive Suite Interiors ──
  proj_executive_suite_interiors_name: '行政套房室内设计',
  proj_executive_suite_interiors_address: '马卡蒂市',
  proj_executive_suite_interiors_category: '室内设计',
  proj_executive_suite_interiors_description: '这一为马卡蒂某领先金融机构打造的行政套房室内项目，充分展现了工作室在企业室内设计上的理念：严谨、精炼、深思熟虑。设计任务书要求空间既能彰显权威与自信，又保持温暖的人性尺度。方案采用深色胡桃木、拉丝黄铜与磨光大理石的克制调色板，点缀以精心甄选的菲律宾当代艺术作品。定制木作与专属家具确保每一元素都精准契合客户需求。',
  proj_executive_suite_interiors_fp0: '行政层平面图',
  proj_executive_suite_interiors_fp1: '董事会层平面图',
  proj_executive_suite_interiors_fp2: '接待区与休息室',

  // ── Project 8: Waterfront Villas ──
  proj_waterfront_villas_name: '滨水别墅',
  proj_waterfront_villas_address: '三宝颜市',
  proj_waterfront_villas_category: '住宅',
  proj_waterfront_villas_description: '三宝颜滨水别墅是一组私人住宅，旨在颂扬三宝颜半岛非凡的自然环境。每栋别墅均独立选址，以最大化私密性与景观视野，建筑形态回应各地块的具体条件。设计语言植根于当地查瓦卡诺文化遗产，以当代手法重新诠释拱形柱廊、赤陶屋瓦与郁郁葱葱的庭院花园。最终呈现出一组既超越时间又深深扎根于所在之地的住宅。',
  proj_waterfront_villas_fp0: '总平面图',
  proj_waterfront_villas_fp1: '首层平面图',
  proj_waterfront_villas_fp2: '上层平面图',

  // ── Project 9: City Medical Plaza ──
  proj_city_medical_plaza_name: '城市医疗广场',
  proj_city_medical_plaza_address: '宿务市',
  proj_city_medical_plaza_category: '医疗',
  proj_city_medical_plaza_description: '宿务市城市医疗广场是一座综合性门诊医疗设施，旨在满足米沙鄢地区日益增长的医疗需求。建筑围绕中央中庭组织，作为主要导视轴线，将自然光引入平面深处，为患者与访客创造清晰、无压力的环境。外立面采用穿孔铝板遮阳系统，在过滤强烈热带阳光的同时，保持与周边城市环境的通透感与联系。',
  proj_city_medical_plaza_fp0: '首层平面图',
  proj_city_medical_plaza_fp1: '二层平面图',
  proj_city_medical_plaza_fp2: '中庭剖面图',

  // ── Project 10: Boutique Hotel Downtown ──
  proj_boutique_hotel_downtown_name: '市中心精品酒店',
  proj_boutique_hotel_downtown_address: '马尼拉',
  proj_boutique_hotel_downtown_category: '酒店',
  proj_boutique_hotel_downtown_description: '这家精品酒店位于马尼拉历史中心，占据一栋经过精心修复的历史建筑，并附有当代后翼扩建。项目在保护与创新之间寻求平衡——保留原建筑华丽的外立面与高挑的室内空间，同时在扩建部分引入鲜明属于当代的建筑语言。48间客房各具特色，每间均从马尼拉丰富而多层次的历史中汲取灵感进行设计。',
  proj_boutique_hotel_downtown_fp0: '首层平面图',
  proj_boutique_hotel_downtown_fp1: '标准客房层平面图',
  proj_boutique_hotel_downtown_fp2: '屋顶层平面图',

  // ── Project 11: Innovation Campus ──
  proj_innovation_campus_name: '创新园区',
  proj_innovation_campus_address: '达沃市',
  proj_innovation_campus_category: '综合体',
  proj_innovation_campus_description: '达沃创新园区是专为研究、科技与创意产业打造的专属环境。总体规划将一系列灵活的实验室与工作室建筑围绕中央绿轴布置，促进偶发性相遇与跨学科协作。建筑风格刻意低调——作为其中工作与人群的背景——以清水混凝土、耐候钢与大面积玻璃构成统一的材料语言。覆盖式步行连廊将所有建筑相连，在热带雨季提供遮蔽，同时保持与景观的紧密联系。',
  proj_innovation_campus_fp0: '总体规划图',
  proj_innovation_campus_fp1: '实验楼平面图',
  proj_innovation_campus_fp2: '工作室楼平面图',

  // ── Project 12: Corporate Headquarters ──
  proj_corporate_headquarters_name: '企业总部',
  proj_corporate_headquarters_address: '马卡蒂市',
  proj_corporate_headquarters_category: '办公',
  proj_corporate_headquarters_description: '这座为菲律宾领先企业集团打造的总部大楼，是机构自信与建筑雄心的宣言。建筑独特的形态——锥形塔楼与雕塑感冠顶——在马卡蒂天际线上树立了新地标。外立面由集成太阳能遮阳翼的单元式幕墙系统构成，在不损害建筑视觉存在感的前提下实现高水平的能源性能。室内设计与客户密切协作完成，体现了企业的核心价值：创新、诚信与菲律宾自豪感。',
  proj_corporate_headquarters_fp0: '首层平面图',
  proj_corporate_headquarters_fp1: '标准办公层平面图',
  proj_corporate_headquarters_fp2: '行政层平面图',

  // ── Studio Page ──
  studio_about_eyebrow: '关于工作室',
  studio_about_h2: '深刻人性，严谨雕琢的建筑。',
  studio_team_strip_eyebrow: '认识团队',
  studio_team_heading1: '认识塑造',
  studio_team_heading2: '行业的智慧。',

  // Design Process Accordion (studio page)
  studio_accordion_commitment: '我们承担的每一个项目都是一种承诺——对土地、对将居住其中的人们，以及对建筑学本身的承诺。我们为世代而建。',
  studio_accordion_heading1: '我们的设计',
  studio_accordion_heading2: '流程',

  // Contact footer
  contact_footer_discuss: '让我们来讨论您的项目。',
  contact_footer_form_note: '填写表单，我们的团队将与您联系进行咨询。',

  // Process page
  process_back: '返回',
  process_page_subtext: '我们承担的每个项目都遵循一个深思熟虑、协作共进的流程——从第一次对话到最终交付。',

  // Design Process Teaser (studio page)
  studio_teaser_eyebrow: '我们的工作方式',
  studio_teaser_heading: '想了解我们的\n设计流程吗？',
  studio_teaser_desc: '从第一次对话到最终交付——每个项目都遵循围绕您的愿景构建的清晰、协作的六步流程。',
  studio_teaser_cta: '探索我们的流程',
  studio_teaser_stages: '6个阶段 · 从设计任务书到竣工',
  studio_teaser_step1: '01 发现',
  studio_teaser_step2: '02 概念',
  studio_teaser_step3: '03 深化',
  studio_teaser_step4: '04 文件',
  studio_teaser_step5: '05 施工',
  studio_teaser_step6: '06 竣工',

  // Studio CTA
  studio_cta_label: '02 / 合作',
  studio_cta_headline: '每一座伟大的建筑都始于一次对话。',
  studio_cta_desc: '无论您有一块场地、一张草图，还是仅仅一个想法——我们都很乐意倾听。我们的团队每年承接数量有限的项目，以确保每个项目都能获得我们全部的专注与深度。',
  studio_cta_btn: '开始对话',
  studio_about_headline: '以清晰与克制\n塑造建筑。',
  studio_about_intro: 'FS Architects 于2008年在马尼拉创立，致力于深思熟虑的设计艺术。我们跨越不同尺度开展工作——从亲密的室内空间到大型公共建筑——始终秉持一个信念：建筑应服务于人、尊重场所、经久不衰。',
  studio_about_intro_short: 'Lorem ipsum dolor sit amet, consectetuer adipiscing',
  studio_principal_name: 'Denza',
  studio_philosophy_label: '我们的理念',
  studio_philosophy_p1: 'FS Architects 是一家建筑事务所，深信建筑必须以生命的节奏前行：从容、深思熟虑、以人为本。秉持慢建筑哲学，我们以用心与精准对待每一个项目，证明成功的设计源于深思熟虑的工艺与平静文化修养之间的平衡。',
  studio_philosophy_p2: '每个项目都从倾听开始。我们投入时间去理解客户的生活、他们的愿景，以及每个场地的具体条件。',
  studio_quote: '我们不为照片而设计，我们为其中的生活而设计。',

  studio_founded_label: '创立年份',
  studio_projects_label: '已完成项目',
  studio_offices_label: '进行中项目',
  studio_team_label: '团队成员',
  studio_principal_credentials_btn: '查看资质',

  // Team
  studio_team_eyebrow: '团队成员',
  studio_team_rest_eyebrow: '团队',
  studio_team_headline: '认识我们的团队',
  studio_team_subtext: '一支由建筑师、设计师与思考者组成的跨学科团队，以对工艺的共同承诺凝聚在一起。',
  studio_team_francisco_name: 'Fretz I. Suralta',
  studio_team_francisco_title: '首席建筑师',
  studio_team_francisco_bio: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.',
  studio_team_francisco_bio_extended: 'Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.',
  studio_team_sofia_name: 'Sofia Reyes',
  studio_team_sofia_title: '设计合伙人',
  studio_team_sofia_bio: 'Sofia 以空间体验与人性尺度为核心，主导工作室的设计方向。她毕业于菲律宾大学迪利曼分校及伦敦建筑联盟学院，为每个项目带来全球视野。',
  studio_team_marco_name: 'Marco Villanueva',
  studio_team_marco_title: '项目建筑师',
  studio_team_marco_bio: 'Marco 负责监督工作室最复杂项目的技术开发。他在结构体系与建筑技术方面的专业知识，确保每个设计既可建造又兼具美感。',
  studio_team_elena_name: 'Elena Cruz',
  studio_team_elena_title: '室内设计负责人',
  studio_team_elena_bio: 'Elena 主持室内设计实践，打造精致、触感丰富、深思熟虑的空间环境。她在定制家具设计与材料策划方面具有独特专长。',
  studio_team_rafael_name: 'Rafael Mendoza',
  studio_team_rafael_title: '高级合伙人',
  studio_team_rafael_bio: 'Rafael 负责管理工作室医疗与公共项目组合中的客户关系与项目交付。他沉稳、系统的工作方式确保复杂项目按时以最高标准完成。',
  studio_team_ana_name: 'Ana Lim',
  studio_team_ana_title: '建筑师',
  studio_team_ana_bio: 'Ana 于2019年加入工作室，迅速成为重要的创意声音。她在山坡住宅和海岸度假村项目上的工作因其敏锐与精准而广受认可。',
  studio_team_jesse_name: 'Jesse Keane Catedral',
  studio_team_jesse_title: '初级平面设计师',
  studio_team_jesse_bio: 'Jesse 是一位充满热情的平面设计师，以清晰的意图在创意与媒介之间穿梭。他打造数字产品、塑造品牌形象，并设计吸引人的体验。',

  // Design Process
  studio_process_eyebrow: '我们的工作方式',
  studio_process_headline: '我们的设计流程',
  studio_process_subtext: '经过十五年实践打磨的审慎、协作方法论。',
  studio_process_discovery_title: '发现与倾听',
  studio_process_discovery_desc: '每个项目都从一段延伸的倾听期开始。我们与客户会面，在一天中不同时段造访场地，沉浸于文化与物质环境之中。这一阶段不产生图纸——只产生理解。',
  studio_process_discovery_tag: '阶段 01',
  studio_process_concept_title: '概念发展',
  studio_process_concept_desc: '从研究中浮现出一个核心组织理念。这一概念——首先以草图和实体模型表达——成为所有后续决策的指南针。我们呈现多个方向，并通过对话加以深化。',
  studio_process_concept_tag: '阶段 02',
  studio_process_design_title: '设计深化',
  studio_process_design_desc: '所选概念在所有尺度上同步深化——从建筑与城市的关系到扶手的截面轮廓。我们借助实体模型、数字工具和材料样品对每个元素进行测试与精炼。',
  studio_process_design_tag: '阶段 03',
  studio_process_documentation_title: '技术文件',
  studio_process_documentation_desc: '我们的技术团队编制完整的施工文件，将设计意图转化为精确、可建造的指令。全程与结构、机电及专项顾问紧密协调。',
  studio_process_documentation_tag: '阶段 04',
  studio_process_construction_title: '施工管理',
  studio_process_construction_desc: '我们在整个施工过程中保持密切参与，定期进行现场巡视，及时回应承包商的问询。这种亲力亲为的在场确保建成作品的品质与设计品质相符。',
  studio_process_construction_tag: '阶段 05',
  studio_process_completion_title: '竣工与交付',
  studio_process_completion_desc: '竣工时，我们对照原始设计意图对建成建筑进行全面审查。我们详细记录项目，并在交付后长期为客户提供支持——因为我们相信，我们的责任不止于门前。',
  studio_process_completion_tag: '阶段 06',
  studio_process_cta_text: '准备好就您的项目开始对话了吗？我们很乐意倾听。',
  studio_process_cta_btn: '开始对话',
  studio_process_view_full: '查看完整流程',

  // ── Contact Page ──
  contact_footer_heading: '联系我们',
  contact_footer_desc_before: '让我们来讨论您的项目。',
  contact_footer_form_link: '表单',
  contact_footer_desc_after: '填写表单，我们的团队将与您联系进行咨询。',
  contact_form_eyebrow: '取得联系',
  contact_form_headline: '让我们一起合作。',
  contact_form_subtext: '告诉我们您的项目，我们将在两个工作日内回复您。',
  contact_field_name: '姓名',
  contact_field_email: '电子邮件',
  contact_field_subject: '主题',
  contact_field_message: '留言',
  contact_placeholder_name: '您的姓名',
  contact_placeholder_email: 'your@email.com',
  contact_placeholder_subject: '选择主题',
  contact_placeholder_message: '告诉我们您的项目...',
  contact_subject_new_project: '新项目',
  contact_subject_collaboration: '合作',
  contact_subject_press: '媒体与新闻',
  contact_subject_careers: '招聘',
  contact_subject_general: '一般咨询',
  contact_form_submit: '发送消息',
  contact_form_sending: '发送中...',
  contact_form_success: '感谢您。我们将尽快与您联系。',
  contact_form_error: '出现错误，请重试。',

  // ── Careers Page ──
  careers_heading: '招聘',
  careers_intro: '我们陪伴您走过每一步，从第一次对话到项目完成，让整个过程清晰、协作、无压力。',
  careers_why_eyebrow: '为何加入我们',
  careers_why_heading: '一个以意图为基础的工作室。',
  careers_val_growth_title: '成长与学习',
  careers_val_growth_desc: '我们投资于团队成员。从导师计划到设计工作坊，每位成员都有专业和创意成长的工具。',
  careers_val_impact_title: '有影响力的项目',
  careers_val_impact_desc: '参与塑造社区的项目——从医疗设施到综合开发。每个项目背后都有深刻的意义。',
  careers_val_collab_title: '协作文化',
  careers_val_collab_desc: '伟大的建筑来自于伟大的团队合作。我们的工作室营造开放对话、共享创意和各层级相互尊重的氛围。',
  careers_open_eyebrow: '开放职位',
  careers_roles_available: '{{count}} 个职位开放中。',
  careers_role_arch_title: '建筑师',
  careers_role_arch_type: '全职',
  careers_role_arch_location: '宿务',
  careers_role_arch_dept: '设计',
  careers_role_arch_exp: '我们正在寻找一位技术熟练、积极进取的建筑师加入工作室，在多种类型项目的管理和交付中发挥积极作用。',
  careers_role_apprent_title: '学徒',
  careers_role_apprent_type: '全职',
  careers_role_apprent_location: '宿务',
  careers_role_apprent_dept: '设计',
  careers_role_apprent_exp: '我们正在寻找一位热情、注重细节的学徒，准备好在专业工作室环境中成长，并从第一天起做出有意义的贡献。',
  careers_req_revit: '熟练掌握Revit',
  careers_req_org: '具备较强的组织和领导能力',
  careers_req_timelines: '能够管理和监控项目进度',
  careers_req_proactive: '主动分配任务并按时完成',
  careers_req_team: '在协作团队环境中茁壮成长',
  careers_label_experience: '经验',
  careers_label_requirements: '要求',
  careers_apply_btn: '申请此职位',
  careers_hero_line1: '加入一个将设计视为',
  careers_hero_line2: '学科而非趋势的工作室。',
  careers_form_heading: '想要加入团队吗？',
  careers_form_desc: '选择您要申请的职位，填写您的详细信息，并附上您的作品集或简历。我们会仔细审阅每份申请，如有合适机会将与您联系。',
  careers_form_position: '职位',
  careers_form_position_placeholder: '选择职位…',
  careers_form_open_application: '开放申请',
  careers_form_first_name: '名',
  careers_form_last_name: '姓',
  careers_form_email: '电子邮件',
  careers_form_message: '留言',
  careers_form_upload: '上传简历',
  careers_form_success: '申请已发送——我们会尽快与您联系。',
  careers_form_error: '出现错误，请重试。',
  careers_form_sending: '发送中…',
  careers_form_send: '发送',
};

export default translations;
